import { Injectable } from '@angular/core';

import { FormularBuilder } from './formular-builder';
import { SwodocEvaluationService } from './swodoc-evaluation.service';

@Injectable({ providedIn: 'root' })
export class AuditFormulaService {
  constructor(private swodocEvalService: SwodocEvaluationService) {}

  public evalFormula(formulaItems, auditNodes, withEval = false) {
    if (!formulaItems || !formulaItems.length || !formulaItems[0].value || !auditNodes) {
      return;
    }

    const builder = new FormularBuilder();
    const result = builder.buildFormular(formulaItems, auditNodes);

    if (withEval) {
      let formulaWithReplacedValues = result.formular;
      for (const key in result.assignments) {
        if (result.assignments.hasOwnProperty(key)) {
          formulaWithReplacedValues = formulaWithReplacedValues.replace(
            // escape special chars
            RegExp(`[${key}]`.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'),
            result.assignments[key]
          );
        }
      }
      try {
        // tslint:disable-next-line: no-eval
        return eval(formulaWithReplacedValues);
      } catch (e) {
        console.error(e);
      }
    }

    const input = {
      host: window.location.host,
      protocol: window.location.protocol,
      formula: result.formular,
      assignments: result.assignments,
      worker: true,
    };
    try {
      return this.swodocEvalService.eval(input);
    } catch (e) {
      console.error(e);
    }
  }
}
